import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Shell for /settings and its child routes: just an outlet. The nav list
 * (SettingsHomeComponent) and every section's content each own their full
 * header/back-button/page-container -- this component only exists to give
 * the settings route tree a stable place to mount, so navigating between
 * the list and a section swaps content in <router-outlet> rather than
 * replacing the whole screen. See settings.component.css for how the
 * enter/leave slide is applied to whichever child is currently activated.
 */
@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './settings.component.css',
})
export class SettingsComponent {}
